import Base from "./_BaseComponent";
import $ from "jquery";

class Email extends Base.Component {

	public onMount(): void {
		const email = this.decode(this.element.attr("data-email"));
		switch (this.element.prop("tagName").toLowerCase()) {
			case "a":
				this.element.attr("href", `mailto:${email}`);
				break;
			default:
				this.element.text(email);
				break;
		}
	}

	private decode(value: string): string {
		return window.atob(value).replace(/::/g, "@");
	}

}

export default Base.Init("[data-email]", Email);
